import { commonNames } from './textAnalysis';
import { categories } from './textAnalysis';
import { MESSAGE_TYPES } from './constants';

const actions = {
  [MESSAGE_TYPES.POSITIVE]: [
    'excelled in', 'showed great understanding of', 'helped others understand',
    'demonstrated mastery in', 'made excellent progress in'
  ],
  [MESSAGE_TYPES.NEGATIVE]: [
    'struggled with', 'needs improvement in', 'had difficulty understanding',
    'showed frustration with', 'needs additional support in'
  ],
  [MESSAGE_TYPES.NEUTRAL]: [
    'participated in', 'worked on', 'attended', 'completed assignment for',
    'took notes during'
  ]
};

export const generateRandomObservation = () => {
  const name = commonNames[Math.floor(Math.random() * commonNames.length)];
  const sentiment = Object.values(MESSAGE_TYPES)[Math.floor(Math.random() * 3)];
  const category = Object.keys(categories)[Math.floor(Math.random() * Object.keys(categories).length)];
  const action = actions[sentiment][Math.floor(Math.random() * actions[sentiment].length)];
  
  return `${name} ${action} ${category} class today.`;
};

export const loadDemoProfile = () => {
  const demoStudent = 'Sarah';
  const startDate = new Date(2023, 0, 1); // Jan 1, 2023
  
  return Array.from({ length: 12 }, (_, i) => {
    const timestamp = new Date(startDate);
    timestamp.setMonth(timestamp.getMonth() + i);
    
    const observation = generateRandomObservation();
    const replacedObservation = observation.replace(/^[A-Za-z]+/, demoStudent);

    return {
      id: Date.now() + i,
      text: replacedObservation,
      timestamp,
      names: [demoStudent],
      category: Object.keys(categories)[i % Object.keys(categories).length],
      sentiment: Object.values(MESSAGE_TYPES)[i % 3]
    };
  });
};